<template>
  <portal to="modals" v-if="show">
    <div class="modal fixed absolute--fill touch overflow-auto relative" :class="style">
      <slot></slot>
    </div>
  </portal>
</template>

<script>
export default {
  props: {
    show: { required: true },
    transparent: { default: true }
  },
  methods: {
    dismiss () {
      this.$emit('close')
    }
  },
  watch: {
    show: {
      immediate: false,
      handler: show => {
        if (show) {
          document.getElementById('main').style.setProperty('overflow', 'hidden')
        } else {
          document.getElementById('main').style.removeProperty('overflow')
        }
      }
    }
  },
  computed: {
    style () {
      return this.transparent ? 'bg-black-50' : 'bg-middle'
    }
  },
  created () {
    const escapeHandler = e => {
      if (e.key === 'Escape' && this.show) {
        this.dismiss()
      }
    }
    document.addEventListener('keydown', escapeHandler)
    this.$once('hook:destroyed', () => {
      document.removeEventListener('keydown', escapeHandler)
    })
  }
}
</script>

<style lang="scss" scoped>
.modal {
  z-index: 700;
  min-width: 100vw
}
</style>
